import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class V2CategoryResource<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags V2-Category-Resource
	 * @name GetV2CategoryResources
	 * @summary Gets Response for V2.0 API for store as per the requirements
	 * @request GET:/api/v2/categories
	 * @response `200` `string` default response
	 */
	getV2CategoryResources = (
		query: {
			storeId: string;
			identifier?: string[];
			id?: string[];
			parentCategoryId?: string;
			depthAndLimit?: string[];
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['getV2CategoryResources'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/api/v2/categories`,
				params: _params,
				query: query,
				methodName: 'getV2CategoryResources',
			};
			logger.trace(traceData);
		}
		return this.http.request<string, any>({
			path: `/api/v2/categories`,
			method: 'GET',
			query: query,
			format: params.format ?? 'json',
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
